module.exports = __webpack_public_path__ + "img/taerte.1bc13589.jpg";